import GetCitiesResponseV1 from './models/response/GetCitiesResponseV1';
import GetCitiesSmallResponseV1 from './models/response/GetCitiesSmallResponseV1';

import citiesRepositoryV1 from './repository';

export default citiesRepositoryV1;

export type { GetCitiesResponseV1, GetCitiesSmallResponseV1 };
